import { replaceWithAnimation } from '@/lib/dom';

export function replace(newForm, oldForm, { beforeEnter }) {
  return replaceWithAnimation(newForm, oldForm, {
    beforeEnter
  });
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/transition_slide/replace.js